import Vue from "vue";
import router from "@/router";
import axios, { AxiosInstance } from "axios";

const base = "//" + document.domain + "/api";

const client: AxiosInstance = axios.create({
  baseURL: base,
  headers: { "Content-Type": "application/json" },
  timeout: 0, // unlimited
  withCredentials: true,
});

axios.interceptors.request.use(
  config => {
    if (router.currentRoute.meta?.requiredAuth) {
      // 認証が必要なページにのみセッショントークンをheaderに付与
      config.headers.common["session"] = Vue.$cookies.get("session");
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default client;
